"use client";

import { useEffect, useRef } from "react";
import { OBJECT_LABELS, type ObjectTrack } from "@/lib/navigation/vision/types";
import cls from "./Camera.module.css";

export function DetectionOverlay({ tracks, width, height }: { tracks: ObjectTrack[]; width: number; height: number }) {
    const canvas = useRef<HTMLCanvasElement>(null);
    const latest = useRef({ tracks, width, height });
    useEffect(() => { latest.current = { tracks, width, height }; });
    const draw = useRef<() => void>(() => {});
    useEffect(() => {
        const element = canvas.current;
        if (!element) return;
        const render = () => {
            const bounds = element.getBoundingClientRect();
            if (!bounds.width || !bounds.height) return;
            const ratio = Math.min(window.devicePixelRatio || 1, 2);
            element.width = Math.round(bounds.width * ratio); element.height = Math.round(bounds.height * ratio);
            const context = element.getContext("2d")!;
            context.scale(ratio, ratio); context.clearRect(0, 0, bounds.width, bounds.height);
            const tokens = getComputedStyle(element);
            const accent = tokens.getPropertyValue("--main-color").trim(), white = tokens.getPropertyValue("--white").trim(), black = tokens.getPropertyValue("--black").trim();
            context.font = "12px sans-serif"; context.lineWidth = 2;
            const fit = Math.min(bounds.width / latest.current.width, bounds.height / latest.current.height);
            const renderedWidth = latest.current.width * fit, renderedHeight = latest.current.height * fit;
            const offsetX = (bounds.width - renderedWidth) / 2, offsetY = (bounds.height - renderedHeight) / 2;
            for (const track of latest.current.tracks) {
                const [x, y, width, height] = [offsetX + track.box[0] * renderedWidth, offsetY + track.box[1] * renderedHeight, track.box[2] * renderedWidth, track.box[3] * renderedHeight];
                context.strokeStyle = track.confirmed ? accent : white;
                context.setLineDash(track.confirmed ? [] : [5, 4]); context.strokeRect(x, y, width, height); context.setLineDash([]);
                const label = `${OBJECT_LABELS[track.kind]} · ${Math.round(track.score * 100)}%`;
                const labelWidth = Math.min(bounds.width, context.measureText(label).width + 12);
                const labelX = Math.max(0, Math.min(x, bounds.width - labelWidth)), labelY = Math.max(0, y - 24);
                context.fillStyle = track.confirmed ? accent : white; context.fillRect(labelX, labelY, labelWidth, 22);
                context.fillStyle = track.confirmed ? white : black; context.fillText(label, labelX + 6, labelY + 15);
            }
        };
        draw.current = render; const resize = new ResizeObserver(render); resize.observe(element); render();
        return () => resize.disconnect();
    }, []);
    useEffect(() => draw.current(), [tracks, width, height]);
    return <canvas ref={canvas} className={cls.overlay} aria-label="Рамки розпізнаних орієнтирів" />;
}
